/** 初期パスワード・再設定の結果の見せ方(平文は 1 回だけ)。部品ではなく関数だけ。 */
import { Modal, Typography, message } from "antd";

const { Text, Paragraph } = Typography;

/** 平文をこの1回だけ見せる。閉じたら二度と出ない。 */
export function showSecret(title: string, value: string, note?: string) {
  Modal.info({
    title,
    width: 520,
    content: (
      <>
        <Paragraph copyable={{ text: value }} style={{ wordBreak: "break-all" }}>
          <Text code>{value}</Text>
        </Paragraph>
        <Text type="secondary">{note ?? "この画面を閉じると二度と表示できない。"}</Text>
      </>
    ),
    okText: "閉じた(控えた)",
  });
}

/** 初期パスワードの結果。メールで送れたときは平文を出さない。 */
export function tellPassword(res: {
  username: string;
  password: string;
  passwordDelivered: boolean;
  passwordNote: string;
}) {
  if (res.passwordDelivered) {
    void message.success(`${res.username} の初期パスワードをメールで送った`);
    return;
  }
  showSecret(
    `${res.username} の初期パスワード(この1回だけ)`,
    res.password,
    res.passwordNote || "本人に安全な方法で渡す。",
  );
}

